import loader from '../core/loader'
import env from '../core/env'
import { getSdkUrlCfg } from '../core/getSDKUrlConf'
import { noop } from '../util/lang'
import bridge from '../bridge'

let role = 1

let _appid = 30004

if (env.is('passenger')) {
  _appid = 39013
} else if (env.is('mini')) {
  _appid = 30005
} else if (env.is('weixin')) {
  _appid = 30000
} else if (env.is('mqq')) {
  _appid = 30001
} else if (env.is('alipay')) {
  _appid = 30002
} else {
  _appid = 30004
}

let defaultTrinityOpts = {
  role,
  appid: _appid,
  lang: 'zh-CN',
  country_calling_code: '+86',
  country_id: 156,
  loginType: 'trinity',
  loginJsVersion: '1.8.7'
}

function getSDKUrl (opt = defaultTrinityOpts) {
  const loginJsVersion = opt.loginJsVersion || '1.8.7'
  return getSdkUrlCfg(defaultTrinityOpts.offline, 'internal', 'loginTrinitySDK', loginJsVersion)
}
/**
 * passport 设置
 * @param  {[obj]} opt              设置参数如：role,appid,channel
 */
function setLoginConfig (opt, cb = noop) {
  defaultTrinityOpts = Object.assign(defaultTrinityOpts, opt)
  loader.sdkReady('login', getSDKUrl(opt), sdk => {
    if (sdk && sdk.setConfig) {
      sdk.setConfig(defaultTrinityOpts)
    } else {
      cb(sdk, {errno: -1, errmsg: sdk || '登录sdk加载问题，请检查网络'})
    }
  })
}

function getUserInfo (success = noop, fail = noop) {
  if (env.is('passenger,driver')) {
    bridge.getUserInfo({}, function (res) {
      if (res && res.phone) {
        success({
          token: res.token || res.ticket,
          phone: res.phone,
          uid: res.uid
        })
      } else {
        fail()
      }
    })
    return false
  } else {
    loader.sdkReady('login', getSDKUrl(), sdk => {
      let _trinityLogin = function (sdk) {
        sdk.isLogin(res => {
          if (res && res.login) {
            success({
              token: res.ticket,
              phone: res.cell,
              uid: res.uid
            })
          } else {
            fail(res)
          }
        })
      }
      _trinityLogin(sdk)
    })
  }
}

function isLogin (success = noop, fail = noop) {
  getUserInfo((info) => {
    if (!info.token) {
      fail()
    } else {
      success(info)
    }
  }, fail)
}

function requestLogin (success = noop, fail = noop) {
  // 调起登录,端内已登录状态，也会调起登录框，可用作重新登录
  bridge.requestLogin({}, function (res) {
    if (res && (res.userInfo.token || res.userInfo.ticket) && res.userInfo.phone) {
      // 登录成功
      success({
        phone: res.userInfo.phone,
        token: res.userInfo.token,
        uid: res.userInfo.uid
      })
    } else {
      fail('登录失败')
    }
  })
}

function login (success = noop, fail = noop) {
  if (env.is('passenger,driver')) {
    isLogin(success, function () {
      requestLogin(success, fail)
    })
  } else {
    loader.sdkReady('login', getSDKUrl(), sdk => {
      if (sdk && sdk.login) {
        sdk.login(function (res) {
          success({
            phone: res.cell,
            token: res.ticket,
            uid: res.uid
          })
        }, function (res) {
          fail(res)
        })
      } else {
        fail({ errno: -1, errmsg: '登录sdk加载问题，请检查网络' })
      }
    })
  }
}

function setTicket (token, success = noop, fail = noop) {
  loader.sdkReady('login', getSDKUrl(), sdk => {
    if (sdk && sdk.setTicket) {
      sdk.setTicket(token, res => {
        success(res)
      }, err => {
        fail(err)
      })
    } else {
      fail({ errno: -1, errmsg: '登录sdk加载问题，请检查网络' })
    }
  })
}

function logout (success = noop, fail = noop) {
  if (env.is('passenger')) {
    requestLogin(success, fail)
  } else {
    loader.sdkReady('login', getSDKUrl(), sdk => {
      if (sdk && sdk.logout) {
        sdk.logout(function () {
          success()
        }, function () {
          fail()
        })
      } else {
        fail({ errno: -1, errmsg: '登录sdk加载问题，请检查网络' })
      }
    })
  }
}

export default {
  login,
  logout,
  isLogin,
  setTicket,
  getUserInfo,
  setLoginConfig
}
